import { ListItemIcon, ListItemText, MenuItem, Typography } from "@mui/material";
import { deleteDoc, doc } from "firebase/firestore";
import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { db } from "firebaseApp";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";

export default function DeleteSectionItem({ section }) {

  const auth = useAuth();
  const [confirming, setConfirming] = useState(false);

  const handleDelete = async () => {
    console.log(section);
    console.log(auth.currentUser.uid);
    if(confirming) {
      deleteDoc(doc(db, "documents", section.documentId, "sections", section.id));
    } else {
      setConfirming(true);
    }
  };

  const getColor = () => {
    return confirming ? "error.main" : "text.primary";
  }

  return (
    <MenuItem
      onClick={handleDelete}
      sx={{ 
        minWidth: "180px", 
        color: getColor(),
      }}
    >
      <ListItemIcon
        sx={{
          color: getColor(),
        }}
      >
        <DeleteIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>{confirming ? "Are you sure?" : "Delete"}</ListItemText>
    </MenuItem>
  );

}
